import React from 'react';

const TimelineItem = ({ date, title, company, description, isLeft = true }) => {
  return (
    <div className={`timeline-item ${isLeft ? 'left' : 'right'}`}>
      <div className="timeline-dot"></div>
      <div className="timeline-content">
        <span className="timeline-date">{date}</span>
        <h3>{title}</h3>
        <h4>{company}</h4>
        <p>{description}</p>
      </div>
    </div>
  );
};

export default TimelineItem;
